import React, { Fragment, useRef, useState, useEffect } from 'react'
import PopUp from '../Common/PopUp';
import Filter from '../Common/Filter';
import Table from '../Common/Table';
import { showToast } from '../Common/Messages';
import { useSelector } from 'react-redux';
import { dateFormat } from '../libs/Util';
import { get } from 'jquery';

export function usePrevState(state) {
    const ref = useRef(state);
    useEffect(() => {
        ref.current = state;
    }, [state]);
    return ref.current;
}

const AccessManagement = () => {
    const loginInfo = useSelector(state => state.login);
    const loginUserId = loginInfo.userId;

    const [veiwList, setVeiwList] = useState([]);
    const [listTitle, setListTitle] = useState('');
    const [popupContent, setPopupContent] = useState(null);
    const [categoryList, setCategoryList] = useState([]);
    const [accessList, setAccessList] = useState([]);
    const [filteredGroups, setFilteredGroups] = useState([]);
    const [showContextMenu, setShowContextMenu] = useState(null);

    const accessState = [
        {type:"", name:"전체"},
        {type:"userId", name:"로그인 여부"},
        {type:"companyName", name:"회사명"},
        {type:"admin", name:"관리자 유형"},
        {type:"deptName", name:"부서"},
        {type:"kindName", name:"직무"},
        {type:"userRole", name:"사용자 유형"}
    ];

    useEffect(() => {
        getAccessList();
        getCategoryList();

        const handleClickOutside = (e) => {
            if (!e.target.closest('.context-menu') && !e.target.classList.contains('kebab-24')) {
                setShowContextMenu(null);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    useEffect(() => {
        setVeiwList(accessList);
        setFilteredGroups(accessList);
    }, [accessList]);

    useEffect(() => {
        setListTitle(filteredGroups.length > 0 ? `접근 권한 관리 (${filteredGroups.length})` : "접근 권한 관리");
    }, [filteredGroups]);

    const [position, setPosition] = useState({ x: 0, y: 0 });

    const handleMouseDown = (event) => {
        setPosition({ x: event.clientX, y: event.clientY });
    };

    const getAccessList = () => {
        fetch('datas/oper/accesstype.json', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
        }).then((response) => response.json())
            .then((data) => {
                if (data.length > 0) {
                    setAccessList(data);
                }
            });
    };

    const getCategoryList = () => {
        fetch('datas/oper/accessCategory.json', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
        }).then((response) => response.json())
            .then((data) => {
                setCategoryList(data.category);
            });
    };

    const renderAccessList = () => {
        let list = [];
        for (let i = 0; i < filteredGroups.length; i++) {
            list.push(
                <tr key={i}>
                    <td>{filteredGroups[i].name}</td>
                    <td>{accessState.find(x => x.type === filteredGroups[i].type)?.type ?? ""}</td>
                    <td>{filteredGroups[i].value}</td>
                    <td><button className="btn-admin-more" onClick={e => btnOnPopup(e, filteredGroups[i], i)}><i className="i-btn-more"></i></button></td>
                </tr>
            );
        }
        return list;
    }
    const list = renderAccessList();
    const setHeaders = () => {
        return [
            "권한명",
            "유형",
            "값",
            ""
        ];
    };

    const saveAccess = (accessData) => {
        const newAccessData = [...accessList, accessData];
        const body = {
            menuPath: "oper/accesstype",
            menuTreeJson: JSON.stringify(newAccessData)
        };
        fetch('api/Manager/SaveMenu', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        })
            .then(response => response.json())
            .then(data => {
                showToast('success', '저장이 완료되었습니다.', 3000);
                getAccessList();
                setPopupContent(null);
            })
            .catch(error => console.error('Error save access:', error));
    };

    const openAddAccessPopup = () => {
        setPopupContent(
            <AddAccess
                onClose={setPopupContent}
                groupList={categoryList}
                saveAccess={saveAccess}
                loginUserId={loginUserId}
            />
        );
    };

    const btnOnPopup = () => {
        setPopupContent(null);
    }

    return (
        <div className="content-scroll">
            <div className="content" onMouseDown={handleMouseDown} >
                <div className="content-right">
                    <h3 className='list-title mb-12'>{listTitle}</h3>
                    <div className="list-tools">
                        <div className={`btns-wrap`}>
                            <button className='btn-appr' onClick={openAddAccessPopup}>
                                <i className='icoKdc12 add-12'></i>권한 추가
                            </button>
                        </div>
                    </div>
                    <Table className={"customerlist"} headers={setHeaders()} list={list} />
                    <PopUp setContent={() => btnOnPopup()} content={popupContent} />
                </div>
            </div>
        </div>
    );
}

const AddAccess = (props) => {
    const [accessData, setAccessData] = useState({name: '', type: '', value: '', isSelect: true});
    const handleChange = (e) => {
        const { name, value } = e.target;
        setAccessData({ ...accessData, [name]: value });
    };  

    return (
        <div className="msg-popup center-box overflow-unset">
            <div className="modal">
                <div className="modal-top">
                    <h3 className="modal-title">권한 추가</h3>
                    <button className="btn-close" onClick={() => props.onClose(null)}>
                        <i className="icoKdc32 close"></i>
                    </button>
                </div>
                <div className="modal-cnts">
                    <div style={{ display: "flex", gap: "20px", marginBottom: "12px" }}>
                        <label className="input-label">권한명</label>
                        <input type="text" name="name" className="input-text" placeholder="권한명을 입력하세요." onChange={handleChange} />
                    </div>
                    <div style={{ display: "flex", gap: "20px", marginBottom: "12px" }}>
                        <label className="input-label">유형</label>
                        <select className="input-select" onChange={handleChange} name="type" defaultValue="">
                            {props.groupList.map((group, index) => (
                                <option key={index} value={group}>{group}</option>
                            ))}
                        </select>
                    </div>
                    <div style={{ display: "flex", gap: "20px", marginBottom: "12px" }}>
                        <label className="input-label">값</label>
                        <input type="text" name="value" className="input-text" placeholder="값을 입력하세요." onChange={handleChange} />
                    </div>
                </div>
                <div className="mail-list-btm">
                    <button className="btn-share" onClick={() => props.saveAccess(accessData)}>
                        완료
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AccessManagement;